var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPegotecLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 270,
    height: 73.469,
    viewBox: "0 0 270 73.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Standard-rectangle-title-slogan",
    transform: "translate(1903.877 -132.494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26663",
    "data-name": "Group 26663",
    transform: "translate(-1903.877 132.494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26661",
    "data-name": "Group 26661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26660",
    "data-name": "Group 26660"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27309",
    "data-name": "Path 27309",
    d: "M-1606.279,196.184v15.9c0,6.2-13.159,12.808-13.364,12.911l.006,0a6.316,6.316,0,0,0,3.159-5.471v-5.079c.094-2.323,3.445-4.5,3.445-4.5s-3.35-2.169-3.445-4.494v-5.008c0-.128,0-.255-.012-.382v-.007c.013-.374.448-14.7-4.812-17.82l10.454,6.036A9.137,9.137,0,0,1-1606.279,196.184Z",
    transform: "translate(1672.354 -173.248)",
    fill: "#ea511f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27310",
    "data-name": "Path 27310",
    d: "M-1771.294,141.48c5.26,3.125,4.825,17.446,4.812,17.82a6.319,6.319,0,0,0-3.147-5.082l-16.521-9.539c-.133-.077-.268-.149-.405-.215,0,0-12.391-7.668-17.813-4.691l10.49-6.057a9.144,9.144,0,0,1,9.138,0l13.3,7.679C-1771.391,141.423-1771.342,141.451-1771.294,141.48Z",
    transform: "translate(1822.346 -132.494)",
    fill: "#e92b17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27311",
    "data-name": "Path 27311",
    d: "M-1868.086,174.37a6.32,6.32,0,0,0-5.912.215l-16.495,9.522h0c-.2.1-13.371,6.7-13.378,12.9h0V185.334a9.137,9.137,0,0,1,4.569-7.913l13.209-7.626c.018-.01.035-.022.053-.031l.147-.085C-1880.477,166.7-1868.086,174.37-1868.086,174.37Z",
    transform: "translate(1903.877 -162.398)",
    fill: "#ea511f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_27312",
    "data-name": "Path 27312",
    d: "M-1767.388,264.75v10.958a3.626,3.626,0,0,1-1.815,3.144l-9.49,5.481a3.631,3.631,0,0,1-3.626,0l-9.495-5.481a3.632,3.632,0,0,1-1.811-3.144V264.75a3.637,3.637,0,0,1,1.811-3.144l9.495-5.477a3.609,3.609,0,0,1,3.626,0l9.49,5.477A3.632,3.632,0,0,1-1767.388,264.75Z",
    transform: "translate(1813.543 -233.392)",
    fill: "#e92b17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26662",
    "data-name": "Group 26662",
    transform: "translate(0 21.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27313",
    "data-name": "Path 27313",
    d: "M-1893.671,277.477h0c0-.084-.008-.168-.008-.252v-5.014c-.032-2.347-3.451-4.562-3.451-4.562s3.418-2.21,3.451-4.559v-4.943a6.316,6.316,0,0,1,3.159-5.471l.024-.015c-.2.1-13.371,6.7-13.378,12.9h0v15.926a9.137,9.137,0,0,0,4.569,7.913l5.637,3.255Z",
    transform: "translate(1903.877 -252.662)",
    fill: "#f7a800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27314",
    "data-name": "Path 27314",
    d: "M-1760.84,360.368h0l-16.512,9.533a6.317,6.317,0,0,1-6.318,0l-9.961-5.751v11.777l8.551,4.937a9.144,9.144,0,0,0,9.138,0l23.9-13.8a9.137,9.137,0,0,0,4.569-7.913v-11.7C-1747.476,353.654-1760.635,360.265-1760.84,360.368Z",
    transform: "translate(1813.552 -330.331)",
    fill: "#f7a800"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26664",
    "data-name": "Group 26664",
    transform: "translate(-1828.219 144.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27315",
    "data-name": "Path 27315",
    d: "M-1485.107,203.364h11.994c5.613,0,9.41,4.119,9.41,9.935s-3.8,10.015-9.41,10.015h-4.927v8.925h-7.068Zm10.541,13.892c2.463,0,3.675-1.656,3.675-3.958s-1.212-3.877-3.554-3.877h-3.594v7.835Z",
    transform: "translate(1485.107 -202.879)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27316",
    "data-name": "Path 27316",
    d: "M-1334.445,203.364h18.093v6.058h-11.025v5.25h8.8v6.057h-8.8v5.452h11.59v6.058h-18.658Z",
    transform: "translate(1361.665 -202.879)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27317",
    "data-name": "Path 27317",
    d: "M-1189.651,200.682c7.391,0,11.105,3.836,11.105,3.836l-3.392,5.291a11.489,11.489,0,0,0-7.027-2.666c-6.058,0-8.521,3.877-8.521,8.158,0,5.492,3.8,8.764,8.279,8.764a9.885,9.885,0,0,0,5.856-2.1v-2.221h-4.079v-6.017h10.339v16.315h-5.9v-.807c0-.606.04-1.212.04-1.212h-.081a11.966,11.966,0,0,1-7.592,2.5c-7.391,0-14.175-5.533-14.175-14.983C-1204.8,207.143-1198.455,200.682-1189.651,200.682Z",
    transform: "translate(1255.439 -200.682)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27318",
    "data-name": "Path 27318",
    d: "M-1008.849,200.682c8.723,0,15.1,6.461,15.1,14.74a14.783,14.783,0,0,1-15.1,15.1,14.783,14.783,0,0,1-15.1-15.1C-1023.953,207.143-1017.572,200.682-1008.849,200.682Zm0,23.383c4.321,0,7.794-3.716,7.794-8.643a7.942,7.942,0,0,0-7.794-8.279,7.942,7.942,0,0,0-7.794,8.279C-1016.643,220.35-1013.17,224.065-1008.849,224.065Z",
    transform: "translate(1107.269 -200.682)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27319",
    "data-name": "Path 27319",
    d: "M-829.094,208.848h-9.773v-3.473h23.544v3.473H-825.1v25.039h-4Z",
    transform: "translate(955.622 -204.527)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27320",
    "data-name": "Path 27320",
    d: "M-677.028,205.375h16.557v3.473H-673.03v8.925h10.217v3.473H-673.03v9.168h13.246v3.473h-17.244Z",
    transform: "translate(823.022 -204.527)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27321",
    "data-name": "Path 27321",
    d: "M-537.349,202.693c6.866,0,10.379,3.756,10.379,3.756l-1.979,2.988a13.009,13.009,0,0,0-8.238-3.11c-6.381,0-10.541,4.846-10.541,10.9,0,6.1,4.24,11.267,10.581,11.267a12.9,12.9,0,0,0,8.8-3.716l2.14,2.868a15.288,15.288,0,0,1-11.066,4.523c-8.561,0-14.579-6.542-14.579-14.9A14.231,14.231,0,0,1-537.349,202.693Z",
    transform: "translate(720.458 -202.33)",
    fill: "#030504"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26665",
    "data-name": "Group 26665",
    transform: "translate(-1828.132 182.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27322",
    "data-name": "Path 27322",
    d: "M-1477.639,411.68l2,7.5a11.069,11.069,0,0,1,.217,1.086h.029a7.106,7.106,0,0,1,.188-1.086l1.882-7.5h1.476l-2.678,10.22h-1.665l-1.766-6.63c-.173-.652-.3-1.448-.3-1.448h-.029s-.13.8-.3,1.448l-1.766,6.63h-1.665l-2.606-10.22h1.476l1.809,7.5a9.942,9.942,0,0,1,.188,1.086h.03s.073-.521.217-1.086l2-7.5Z",
    transform: "translate(1484.63 -411.506)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27323",
    "data-name": "Path 27323",
    d: "M-1394.034,411.68h5.935v1.244h-4.5v3.2h3.662v1.244h-3.662v3.287h4.748V421.9h-6.182Z",
    transform: "translate(1410.402 -411.506)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27324",
    "data-name": "Path 27324",
    d: "M-1306.978,410.715a5.261,5.261,0,0,1,3.721,1.347l-.709,1.071a4.663,4.663,0,0,0-2.954-1.115,3.715,3.715,0,0,0-3.778,3.909,3.836,3.836,0,0,0,3.793,4.039,4.625,4.625,0,0,0,3.156-1.332l.767,1.028a5.48,5.48,0,0,1-3.967,1.621,5.144,5.144,0,0,1-5.226-5.342A5.1,5.1,0,0,1-1306.978,410.715Z",
    transform: "translate(1343.332 -410.715)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27325",
    "data-name": "Path 27325",
    d: "M-1240.88,411.68h3.126a5.147,5.147,0,0,1,1.911.232,2.8,2.8,0,0,1,1.723,2.765,2.8,2.8,0,0,1-1.838,2.765v.03a2.929,2.929,0,0,1,.3.463l2.172,3.967h-1.621l-2.157-4.068h-2.186V421.9h-1.433Zm3.488,4.907a1.7,1.7,0,0,0,1.81-1.853,1.673,1.673,0,0,0-.812-1.577,2.813,2.813,0,0,0-1.4-.232h-1.65v3.662Z",
    transform: "translate(1284.918 -411.506)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27326",
    "data-name": "Path 27326",
    d: "M-1179.923,411.68h5.934v1.244h-4.5v3.2h3.662v1.244h-3.662v3.287h4.748V421.9h-6.181Z",
    transform: "translate(1234.974 -411.506)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27327",
    "data-name": "Path 27327",
    d: "M-1125.125,418.961h-3.85l-1.014,2.939h-1.476l3.677-10.22h1.505l3.677,10.22h-1.491Zm-1.925-5.877s-.232.926-.406,1.448l-1.143,3.242h3.1l-1.13-3.242c-.173-.521-.39-1.448-.39-1.448Z",
    transform: "translate(1195.271 -411.506)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27328",
    "data-name": "Path 27328",
    d: "M-1071.732,412.924h-3.5V411.68h8.439v1.244h-3.5V421.9h-1.433Z",
    transform: "translate(1149.201 -411.506)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27329",
    "data-name": "Path 27329",
    d: "M-1010.839,411.68h5.935v1.244h-4.5v3.2h3.662v1.244h-3.662v3.287h4.748V421.9h-6.182Z",
    transform: "translate(1096.438 -411.506)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27330",
    "data-name": "Path 27330",
    d: "M-928.642,418.851a4.032,4.032,0,0,0,2.605,1.1,1.576,1.576,0,0,0,1.767-1.505c0-2.215-4.951-1.737-4.951-4.878a3.027,3.027,0,0,1,3.3-2.853,4.187,4.187,0,0,1,2.9,1.028l-.651,1.187a3.6,3.6,0,0,0-2.244-.883,1.671,1.671,0,0,0-1.853,1.49c0,2.113,4.951,1.549,4.951,4.864a2.946,2.946,0,0,1-3.243,2.881,4.781,4.781,0,0,1-3.387-1.346Z",
    transform: "translate(1029.755 -410.715)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27331",
    "data-name": "Path 27331",
    d: "M-870.375,410.715a5.151,5.151,0,0,1,5.241,5.212,5.229,5.229,0,0,1-5.241,5.356,5.241,5.241,0,0,1-5.255-5.356A5.164,5.164,0,0,1-870.375,410.715Zm0,9.251a3.861,3.861,0,0,0,3.764-4.039,3.791,3.791,0,0,0-3.764-3.909,3.8,3.8,0,0,0-3.778,3.909A3.872,3.872,0,0,0-870.375,419.966Z",
    transform: "translate(985.657 -410.715)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27332",
    "data-name": "Path 27332",
    d: "M-796.409,411.68h1.434v8.975h4.574V421.9h-6.008Z",
    transform: "translate(920.749 -411.506)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27333",
    "data-name": "Path 27333",
    d: "M-746.186,411.68h1.434v6.6a2.339,2.339,0,0,0,2.576,2.475,2.363,2.363,0,0,0,2.606-2.5V411.68h1.433v6.6a3.712,3.712,0,0,1-4.024,3.792,3.713,3.713,0,0,1-4.025-3.792Z",
    transform: "translate(879.599 -411.506)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27334",
    "data-name": "Path 27334",
    d: "M-681.243,412.924h-3.5V411.68h8.439v1.244h-3.5V421.9h-1.433Z",
    transform: "translate(829.261 -411.506)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27335",
    "data-name": "Path 27335",
    d: "M-620.341,411.68h1.433V421.9h-1.433Z",
    transform: "translate(776.491 -411.506)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27336",
    "data-name": "Path 27336",
    d: "M-586.016,410.715a5.152,5.152,0,0,1,5.241,5.212,5.229,5.229,0,0,1-5.241,5.356,5.241,5.241,0,0,1-5.255-5.356A5.164,5.164,0,0,1-586.016,410.715Zm0,9.251a3.861,3.861,0,0,0,3.764-4.039,3.791,3.791,0,0,0-3.764-3.909,3.8,3.8,0,0,0-3.778,3.909A3.872,3.872,0,0,0-586.016,419.966Z",
    transform: "translate(752.673 -410.715)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27337",
    "data-name": "Path 27337",
    d: "M-512.05,411.68h1.419l4.546,6.644c.376.551.854,1.477.854,1.477h.029s-.1-.912-.1-1.477V411.68h1.434V421.9h-1.4l-4.56-6.63c-.377-.565-.854-1.491-.854-1.491h-.029s.1.913.1,1.491v6.63h-1.434Z",
    transform: "translate(687.765 -411.506)",
    fill: "#030504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27338",
    "data-name": "Path 27338",
    d: "M-445.314,418.851a4.031,4.031,0,0,0,2.605,1.1,1.576,1.576,0,0,0,1.767-1.505c0-2.215-4.951-1.737-4.951-4.878a3.027,3.027,0,0,1,3.3-2.853,4.187,4.187,0,0,1,2.9,1.028l-.651,1.187a3.6,3.6,0,0,0-2.244-.883,1.671,1.671,0,0,0-1.853,1.49c0,2.113,4.951,1.549,4.951,4.864a2.946,2.946,0,0,1-3.243,2.881,4.78,4.78,0,0,1-3.387-1.346Z",
    transform: "translate(633.749 -410.715)",
    fill: "#030504"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPegotecLogo);
export default __webpack_public_path__ + "static/media/pegotec-logo.4b54821f9cb788057eca0fcb9bf8a40a.svg";
export { ForwardRef as ReactComponent };